import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '../../../../components';
import { PickLine } from './PickLine';
import type { SpotlightPickItem } from './types';
import * as S from './SpotlightPick.styles';

export type SpotlightPickProps = { item: SpotlightPickItem };

/** The i18n context of the pick's button (its catalogs' `<key>_cta`). */
const CTA_CONTEXT = 'cta';

/**
 * Lumio's pick in the strip (the prototype's 'pick' variant): "Getting started" over the title (two lines at most, its
 * room the strip's, the whole of it in its title tooltip), the line, the button and a quiet Dismiss. A score card's width, never the strip's
 * (SpotlightPick.styles). Both buttons report themselves through the item's handlers.
 */
export const SpotlightPick = ({ item }: SpotlightPickProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <S.Pick
      role="group"
      aria-label={item.ariaLabel}
      data-ftux={item.target}
      data-fresh={item.fresh ? 'true' : undefined}
    >
      <S.PickHeading>
        {/* As the piece's pop-up tags it. */}
        <S.PickEyebrow text="Getting started" />
        <S.TitleSlot data-card="title">
          <S.PickTitle text={item.title} title={t(item.title)} />
        </S.TitleSlot>
      </S.PickHeading>
      <PickLine text={item.body} />
      <S.PickActions>
        <S.PickCta type="button" onClick={item.onActivate}>
          {/* A button's words: its `_cta` translation where a language's verb and noun differ (Spanish Revisar, not the
              product's Revisión), else its own key. */}
          <S.PickCtaLabel text={t(item.cta, { context: CTA_CONTEXT })} raw />
        </S.PickCta>
        {item.onDismiss ? (
          <S.PickDismiss type="button" onClick={item.onDismiss}>
            <Text text="Dismiss" />
          </S.PickDismiss>
        ) : null}
      </S.PickActions>
    </S.Pick>
  );
};

export default SpotlightPick;
